import styled from 'styled-components';

export const MultiplePrewievContainer = styled.div`
  overflow: hidden;

  &.desktop,
  &.laptop {
    min-width: 178px;
    width: 178px;
    height: 136px;
  }

  &.tablet {
    min-width: 120px;
    width: 120px;
    height: 120px;
  }
`;

export const MobileContainer = styled.div`
  position: relative;
  padding-top: 60%;

  &:before {
    display: block;
    content: '';
    width: 100%;
  }
`;

export const MobileContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
